export const baseStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 12,
  borderColor: "#7A909E",
  borderStyle: "dashed",
  outline: "none",
  transition: "border .24s ease-in-out",
  height: 125,
  width: 350,
  backgroundColor: "#FFFFFF",
};

export const focusedStyle = {
  borderColor: "#2196f3",
};

export const acceptStyle = {
  borderColor: "#00e676",
};

export const rejectStyle = {
  borderColor: "#ff1744",
};



// WEBPACK FOOTER //
// ./src/components/formik/uploadCustomWatchLists/uploadCustomWatchListsStyles.js